(function(root){
  'use strict';
  const excluded=new Set(['wave-earrings','wave-mini-earrings']);
  const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();
  const identity=(p,v)=>norm(p.model||p.handle)+'|'+norm(v.color||v.title);
  const rules={
    canAdd(items,p,v){
      if(!p||!v||!p.eligible||excluded.has(p.handle))return 'Questo prodotto appartiene a La Maison e ha un prezzo dedicato.';
      if(!v.available||v.stock<1)return 'Questa variante è esaurita.';
      return null;
    },
    identity,
    value(items){return items.reduce((sum,x)=>sum+x.price,0);},
    total(items){return items.length*1250;},
    cartState(lines,products){
      const flow=lines.filter(line=>products.has(String(line.product_id)));
      const duplicate=false;
      const count=flow.reduce((sum,line)=>sum+line.quantity,0);
      return {flow,count,duplicate,valid:!duplicate};
    },
    valid(items){return items.length>=1&&items.every(x=>x.eligible&&!excluded.has(x.handle)&&Number.isInteger(x.price)&&x.price>=0);}
  };
  if(typeof module==='object'&&module.exports)module.exports=rules;else root.MASetRules=rules;
})(typeof window==='undefined'?globalThis:window);
